// extracted by mini-css-extract-plugin
export default {"main":"SimilarProducts_main__2x3TT"};